import { GlobalErrorBoundary } from "@/components/error/boundary/global-error-boundary";
import { AppLifecycleProvider } from "@/components/providers/app-lifecycle-provider";
import { RevenueCatProvider } from "@/components/providers/revenue-cat-provider";
import { SafeAreaProvider } from "@/components/providers/safe-area-provider";
import { TrackingProvider } from "@/components/providers/tracking-provider";
import { env } from "@/constants/env";
import { getQueryClient } from "@/utils/tanstack-query";
import { ClerkProvider } from "@clerk/clerk-react";
import { QueryClientProvider } from "@tanstack/react-query";
import React from "react";
import { root } from "./vars";

const queryClient = getQueryClient();

const clerkProxyUrl =
  env.VITE_CLERK_PROXY_URL && env.VITE_CLERK_PROXY_URL.length > 0
    ? env.VITE_CLERK_PROXY_URL
    : undefined;

export const renderWithProviders = async (content: React.ReactNode) => {
  root.render(
    <React.StrictMode>
      <GlobalErrorBoundary>
        <ClerkProvider publishableKey={env.VITE_CLERK_PUBLISHABLE_KEY} proxyUrl={clerkProxyUrl}>
          <RevenueCatProvider>
            <QueryClientProvider client={queryClient}>
              <AppLifecycleProvider>
                <TrackingProvider>
                  <SafeAreaProvider>{content}</SafeAreaProvider>
                </TrackingProvider>
              </AppLifecycleProvider>
            </QueryClientProvider>
          </RevenueCatProvider>
        </ClerkProvider>
      </GlobalErrorBoundary>
    </React.StrictMode>,
  );
};
